import { render, staticRenderFns } from "./EventManagerForm.vue?vue&type=template&id=2911077a"
import script from "./EventManagerForm.vue?vue&type=script&lang=js"
export * from "./EventManagerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports